import { useState } from 'react';

import {
  useDelegationTeammatesQuery,
  useSentDelegationsQuery,
} from './action-card-delegation.query';

import type { FeedTabsStore } from '@littlebird/sdk';

export const useDelegatedSummary = () => {
  const hasTeammates = (useDelegationTeammatesQuery().data?.length ?? 0) > 0;
  const sent = useSentDelegationsQuery().data ?? [];
  // A delegation is open until the teammate's copy is done or dismissed
  const openCount = sent.filter(({ status }) => status === 'pending').length;
  return { available: hasTeammates || sent.length > 0, openCount };
};

/**
 * The feed's Delegated view, open for the tab that opened it: switching tabs
 * closes it without extra bookkeeping.
 */
export const useDelegatedView = (store: FeedTabsStore) => {
  const [openTabId, setOpenTabId] = useState<string>();
  const { available } = useDelegatedSummary();
  const open = openTabId !== undefined && openTabId === store.activeTab.id;

  const toggle = () => {
    if (open) {
      setOpenTabId(undefined);
      return;
    }
    setOpenTabId(store.activeTab.id);
  };

  return {
    available,
    open,
    toggle,
  };
};

/** Cards the user sent to a teammate; the teammate's copy replaces them in the feed */
export const useDelegatedSourceCardIds = (): ReadonlySet<string> =>
  new Set(
    (useSentDelegationsQuery().data ?? []).map(
      (delegation) => delegation.sourceCardId
    )
  );

export type DelegatedView = ReturnType<typeof useDelegatedView>;
